export enum ScheduleOutcome {
    Completed = 1,
    Rescheduled = 2,
    NotReached = 3,
}
